import type { NavigateFunction } from 'react-router-dom';
import { SecondarySidebar, SecondarySidebarSection, type AppLayoutApi } from '@jordan/ui';

const ITEMS = [{ label: 'Image Library', icon: 'ph-images', path: '/media/images' }] as const;

/** Shared secondary (left) sidebar for the Media section. `pathname` decides the active item. */
export function mediaSidebar(navigate: NavigateFunction, pathname: string) {
  return function MediaSecondarySidebar(api: AppLayoutApi) {
    const go = (path: string) => {
      navigate(path);
      api.closeSecondarySidebar();
    };
    return (
      <SecondarySidebar title="Media" mobileExpanded={api.secondarySidebarExpanded} onClose={api.closeSecondarySidebar}>
        <SecondarySidebarSection title="Media" flush>
          <ul className="nav nav-sidebar my-2" data-nav-type="accordion">
            {ITEMS.map((it) => (
              <li className="nav-item" key={it.path}>
                <a
                  href={it.path}
                  className={`nav-link ${pathname === it.path ? 'active' : ''}`.trim()}
                  onClick={(e) => {
                    e.preventDefault();
                    go(it.path);
                  }}
                >
                  <i className={`${it.icon} me-3`} />
                  {it.label}
                </a>
              </li>
            ))}
          </ul>
        </SecondarySidebarSection>
      </SecondarySidebar>
    );
  };
}
